<script setup lang="ts">
import type { NavigationMenuItem } from '#ui/types'

defineProps<{
  isOpen: boolean
  menuItems: NavigationMenuItem[][]
  bottomItems: NavigationMenuItem[]
}>()

const { getNavigationUrl } = useNavigationPreservation()
const logoUrl = getNavigationUrl('/initiatives')
</script>

<template>
  <UDashboardSidebar
    :open="isOpen"
    :ui="{
      footer: 'border-t border-default',
      body: 'gap-2 p-0',
      header: 'mt-2 mb-6',
    }"
    :min-size="12"
    :default-size="12"
  >
    <template #header>
      <div class="flex flex-col items-center justify-center p-2">
        <NuxtLink :to="logoUrl">
          <svg
            viewBox="0 0 739 326"
            xmlns="http://www.w3.org/2000/svg"
            xml:space="preserve"
            fill-rule="evenodd"
            clip-rule="evenodd"
            stroke-linejoin="round"
            stroke-miterlimit="2"
            class="h-20 w-20"
          >
            <path
              fill-rule="nonzero"
              d="M185.348 215.684h29.883v10.157c0 36.328-6.185 59.017-18.554 68.066-12.37 9.05-43.49 13.574-93.36 13.574-44.661 0-73.047-7.975-85.156-23.926C6.051 267.605-.003 230.072-.003 170.957c0-46.223 1.367-75.292 4.102-87.206 2.734-11.915 10.546-22.559 23.437-31.934C42.64 40.88 75.257 35.411 125.388 35.411c33.984 0 56.868 5.274 68.652 15.82 11.784 10.547 17.676 30.925 17.676 61.133l.195 7.226h-29.883l-.195-8.202c0-21.485-3.483-35.287-10.45-41.407-6.965-6.12-22.688-9.18-47.167-9.18-42.97 0-69.206 3.58-78.71 10.742-9.506 7.162-14.26 27.019-14.26 59.571 0 74.87 3.19 118.75 9.57 131.64 6.38 12.891 28.19 19.336 65.43 19.336 35.416 0 57.52-2.8 66.308-8.398 8.79-5.6 13.184-19.661 13.184-42.188l-.39-15.82ZM434.177 38.145v25.391h-149.61l-1.37 80.86h.59c10.416-14.714 33.789-22.071 70.114-22.071 35.158 0 59.147 6.054 71.977 18.164 12.825 12.11 19.235 34.895 19.235 68.36 0 40.884-6.086 67.545-18.258 79.98-12.178 12.435-38.12 18.652-77.835 18.652-39.451 0-65.854-4.622-79.199-13.867-13.345-9.245-20.02-27.54-20.02-54.883v-10.157h28.319c0 24.09 3.746 39.03 11.233 44.825 7.487 5.794 26.594 8.691 57.321 8.691 32.166 0 51.825-3.71 58.988-11.132 7.158-7.423 10.74-27.735 10.74-60.938 0-26.823-4.001-43.912-12.008-51.27-8.012-7.356-26.6-11.035-55.767-11.035-40.623 0-62.888 8.529-66.793 25.586h-27.151V38.145h179.494Z"
            />
            <path
              fill="#f26a28"
              fill-rule="nonzero"
              d="M479.584 325.1V-.003h147.19c43.982 0 73.635 7.66 88.957 22.983 15.323 15.322 22.984 44.896 22.984 88.72 0 43.505-7.303 72.404-21.912 86.694-14.608 14.29-44.141 21.436-88.6 21.436l-14.29.238H541.27V325.1h-61.686Zm61.686-156.955h70.261c27.946 0 45.69-3.215 53.231-9.646 7.543-6.43 11.314-21.634 11.314-45.61 0-27.469-3.136-44.498-9.408-51.088-6.272-6.59-22.587-9.884-48.944-9.884H541.27v116.228Z"
            />
          </svg>
        </NuxtLink>
      </div>
    </template>

    <template #default>
      <!-- Show full navigation menus -->
      <template v-for="(group, index) in menuItems" :key="`expanded-${index}`">
        <UNavigationMenu
          :items="group"
          orientation="vertical"
          :ui="{ item: 'px-2' }"
        />
        <USeparator v-if="index < menuItems.length - 1" />
      </template>
    </template>

    <template #footer>
      <!-- Show full navigation menu -->
      <UNavigationMenu :items="bottomItems" orientation="vertical" />
    </template>
  </UDashboardSidebar>
</template>
